import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from '@/query-keys';

/**
 * Invalidate every query that depends on campaign state for the current opening.
 *
 * Call this after any mutation that changes a campaign (create, update, toggle,
 * accept/reject recommendation, etc.). React Query will then refetch the active
 * subscribers across the opening-details page.
 */
export function useInvalidateCampaignQueries() {
  const queryClient = useQueryClient();

  return useCallback(
    () =>
      Promise.all([
        queryClient.invalidateQueries({
          queryKey: queryKeys.openingDetails.detail,
        }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.openingDetails.channels.list,
        }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.openingDetails.channels.sourcingFunnels,
        }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.openingDetails.channels.campaignDetails,
        }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.openingDetails.channels.recommendations,
        }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.openingDetails.channels.reach,
        }),
      ]),
    [queryClient],
  );
}
